import { Button } from "antd";
import imp404 from "@images/404_imp.png";
import space404 from "@images/404_space.jpg";
import { getWordpressUrl } from "@lib/wordpressVars";

interface Error404Props {
	className?: string;
	style?: string;
}

const defaultProps: Error404Props = {};

const Error404 = ({ className, style }: Error404Props) => {

	return (
		<article
			className="content-not-found"
			style={{ backgroundImage : `url(${getWordpressUrl(space404)})` }
			}>
			<section className="entry-content d-flex">
				<div className="col">
					<img src={getWordpressUrl(imp404)} alt="art" />
				</div>
				<div className="col d-flex">
					<header className="header-404">
						<h1>404</h1>
					</header>
					<div className="cta-wrapper">
						<p>Page Missing From Reality<br /><small>Unless you're a 5th Dimensional Imp</small></p>
						<Button type={`primary`} href="/">Take Me Home!</Button>
					</div>
				</div>
			</section>
		</article>
	);
};

Error404.defaultProps = defaultProps;

export default Error404;
